var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-header"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"width":"200px"}},[_c('ButtonDefault',{attrs:{"text":_vm.buttonLabel},nativeOn:{"click":function($event){return _vm.$router.push({name: _vm.routeNameButton})}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }